import { render, staticRenderFns } from "./EcommerceCompanyTable2.vue?vue&type=template&id=726f9e23&scoped=true"
import script from "./EcommerceCompanyTable2.vue?vue&type=script&lang=js"
export * from "./EcommerceCompanyTable2.vue?vue&type=script&lang=js"
import style0 from "./EcommerceCompanyTable2.vue?vue&type=style&index=0&id=726f9e23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726f9e23",
  null
  
)

export default component.exports